export enum MainGlobalEvents {
  HEADER_CONFIG = 'landing-header-config-event',
  HEADER_DOWNLOAD_EVENT = 'handle-download-event',
  SCREEN_NAME = 'screen-name-event',
}
